import { http } from '../../../api'

const orders = {
  namespaced: true,
  state: {
    ordersList: null
  },
  actions: {

    getMessages: ({ commit }, params) => {
      let url = '/orders'
      if (params) {
        const q = new URLSearchParams(params)
        url = url + '?' + q.toString()
      }
      return http.get(url).then(res => {
        commit('setMessages', res.data.data)
        return res.data
      })
    },
    getOrder: ({ commit }, id) => {
      return http.get('/orders/' + id).then(res => {
        return res.data
      })
    },
    deleteItem: ({ commit }, id) => {
      return http.delete('/orders/' + id).then(res => {
        commit('deleteBlog', id)
      })
    }
  },
  mutations: {
    setMessages (state, data) {
      state.ordersList = data
    },
    deleteBlog (state, id) {
      state.ordersList = state.ordersList.filter(item => item.id !== id)
    }
  },
  getters: {
    ordersList: state => state.ordersList
  }
}

export default orders
